import React, { useMemo, useState, useEffect, useRef, useCallback } from "react";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-enterprise";
import "ag-grid-enterprise/styles/ag-grid.css";
import "ag-grid-enterprise/styles/ag-theme-alpine.css";
import axios from "axios";
import { host } from "../variables.js";
import { Button, Input, message, Modal, Select } from "antd";
import textLinkRenderer from "./textLinkRenderer";
import TextLinkRenderer1 from "./textLinkRenderer1/index.jsx";
import PdfRenderer from "./PdfRenderer";
import { Link, useParams } from "react-router-dom";

import { SearchOutlined, DownloadOutlined, FileOutlined } from '@ant-design/icons';
import "../outputTable/Sap.css";
import { useRecoilState } from "recoil";
import { bookingDataState } from "../state.js";
import Document from "./Document.js";
import { filter } from "lodash";




const { Option } = Select;
const App = () => {
  const gridRef = useRef(null);
  const containerStyle = useMemo(
    () => ({ width: "80vw", height: "100vh" }),
    []
  );
  const gridStyle = useMemo(() => ({ height: "95%", width: "95%", marginTop: '10px' }), []);
  const [data, setData] = useRecoilState(bookingDataState)
  const [modalVisible, setModalVisible] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState('1st');
  const [pdfLink, setPdfLink] = useState("");
  let [pdfFieldName, setpdfFieldName] = useState("")
  const [selectedPriority, setSelectedPriority] = useState('');
  const [selectedFilterPriority, setSelectedFilterPriority] = useState('');
  const selectedFilterPriorityRef = useRef(selectedFilterPriority);



  const getServerSideDatasource = (data) => {
    return {
      getRows: async (gridParams) => {
        console.log("[Datasource] - rows requested by grid: ", gridParams.request);
        const selectedPriority = selectedFilterPriorityRef.current;
        console.log(selectedFilterPriority, "selected priority")

        const requestBody = {
          ...gridParams.request,
          database: "Hotel_Invoices_Recon",
          table: "report_invoice_2b_plan",
          // priority: selectedPriority,
        };
        const levelMapping = {
          "1st": 1,
          "2nd": 2,
          "3rd": 3, 
          "4th": 4
        };

        console.log("Request body:", requestBody);

        try {
          const response = await fetch('https://stage-apiplatform.finkraftai.com/api/finalytics/tables/data/preview_test', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody),
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();
          console.log("Data fetched:", data);

          const totalCount = data.data.totalCount;
          console.log("Total Count:", totalCount);

          updateTotalCountUI(totalCount);
          setColumnDefinitions(gridApi, data.data, levelMapping, selectedLevel);


          if (data && Array.isArray(data.data.rows)) {
            gridParams.success({
              rowData: data.data.rows,
              // rowCount: data.lastRow,
            });
          } else {
            gridParams.fail();
          }
        } catch (error) {
          console.error("Error fetching server-side data:", error);
          gridParams.fail();
        }
      },
    };
  };

  function updateTotalCountUI(totalCount) {
    const totalCountElement = document.getElementById('total-count');
    if (totalCountElement) {
      totalCountElement.innerText = `Total Count: ${totalCount}`;
    }
  }





 

  const handlePriorityFilterChange = (value) => {
    console.log(value, "priority value")
    setSelectedFilterPriority(value);
    selectedFilterPriorityRef.current = value;
    console.log(gridApi, "inside priority change")
    // if (gridApi) {
    //   gridApi.refreshServerSide(value); 
    // }
  };

  const getSelectedGroupKeys = () => {
    const selectedGroupKeys = [];
    const selectionState = gridApi.getServerSideSelectionState();
  
    if (selectionState && Array.isArray(selectionState.toggledNodes)) {
      selectionState.toggledNodes.forEach(toggledNode => {
        if (toggledNode.selectAllChildren && toggledNode.nodeId) {
          // Fetch the complete node information using gridApi and the nodeId
          const node = gridApi.getRowNode(toggledNode.nodeId); // Example method to get node
          if (node && node.data && node.data.validated_data) {
            selectedGroupKeys.push(node.data.validated_data.workspace); // Extract workspace/client name
          }
        }
      });
    }
  
    return selectedGroupKeys;
  };
  const handleFilterApply = async () => {
    console.log(selectedFilterPriorityRef.current, "applying filter");

    if (gridApi) {
      const priorityLevel = selectedFilterPriorityRef.current; 
      try {
        const filterModel = gridApi.getFilterModel();
        console.log(gridApi,"gridApi")
        console.log(gridApi.getFilterModel(),"filter model check")
        const database = "Hotel_Invoices_Recon";
        const collection = "report_invoice_2b_plan";
        const selectedGroupKeys = getSelectedGroupKeys(); 
        console.log(selectedGroupKeys,"selectedGroupKeys")

        const requestBody = {
          database,
          collection,
          filterModel,
          priorityLevel,
          selectedGroupKeys,
          
        };

        console.log(requestBody, "Request Body for Priority Apply");

        const response = await fetch(
          "https://stage-apiplatform.finkraftai.com/api/finalytics/tables/data/priorityApply",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(requestBody),
          }
        );

        const result = await response.json();
        console.log(result, "API Response for Priority Apply");

        // Refresh grid server-side with new data
        gridApi.refreshServerSide();
      } catch (error) {
        console.error("Error in handleFilterApply:", error);
      }
    }
  };




  const onIconClick = (docs) => {
    console.log("docs", docs)
    setDocuments(docs);
    setModalVisible(true);
    setSelectedDocuments(docs);
  };

  const closeModal = () => {
    setModalVisible(false);
    setDocuments([]);
  };



  const handleCancelButton = () => {
    setIsFilterModalVisible(false);
  };




  const generateColumnDefs = (data, level) => {
    console.log(data, "data*******")
    console.log(level, "level")
    if (!data || data.length === 0) return [];
    let columnDefsMap = {};

    columnDefsMap = {
      Workspace: {
        headerName: "Workspace",
        field: "validated_data.workspace",
        cellRenderer: (params) => params.value || "N/A", // Customize as needed
        minWidth: 240,
        filter: "agTextColumnFilter",
        sortable: true,
        resizable: true,
        enableRowGroup: true,
        checkboxSelection: () => {
          console.log("Checkbox enabled for all nodes");
          return true;
        },
      },
      Hotel: {
        headerName: "Hotel Name",
        field: "mapped_invoice_data.hotel_name",
        cellRenderer: (params) => params.value || "N/A", // Customize as needed
        minWidth: 240,
        filter: "agTextColumnFilter",
        sortable: true,
        resizable: true,
        enableRowGroup: true,
      
      },

    }

    const urlPattern = /^https:\/\/files\.finkraft\.ai\/[a-f0-9]{32}$/;

    // console.log(columnDefsMap, "*******************")

    const determineFilterType = (values) => {
      if (!values || values.length === 0) return null;
      const sampleValue = values.find((value) => value !== null && value !== undefined);

      if (typeof sampleValue === "number") {
        return "agNumberColumnFilter";
      } else if (typeof sampleValue === "string") {
        return "agTextColumnFilter";
      } else if (typeof sampleValue === "boolean") {
        return "agSetColumnFilter";
      } else if (Array.isArray(sampleValue)) {
        return null;
      } else if (typeof sampleValue === "object") {
        return null;
      }
      return null;
    };

    let pdfFieldName = "";
    const normalizedData = Array.isArray(data) ? data : [data];
    const priorityFields = ["validated_data.workspace", "mapped_invoice_data.hotel_name","mapped_invoice_data", "two_b_data","booking_match"]; 

   
    normalizedData.forEach((item) => {
      Object.keys(item).forEach((key) => {
     
        const value = item[key];
        const headerName = key.replace(/_/g, " ");
        const values = normalizedData.map((row) => row[key]);
        console.log("Key:", key, "Value:", value, "Type of Value:", typeof value);
        const filterType = determineFilterType(values);
        if (typeof value !== "object" || value === null) {
          if (!columnDefsMap[headerName]) {
            columnDefsMap[headerName] = {
              headerName: headerName,
              field: key,
              filter: filterType,
              // filter: "agNumberColumnFilter",
              enableRowGroup: true,
              sortable: true,
              resizable: true,
              minWidth: 300,
              cellRenderer: (params) => {
                console.log("***************",params.value)
                console.log("@@@@@@@@@@@@@@@@@",key)
                const val = params.value||params.data?.[key];
                console.log(val,"val@@@@@")
                

                if (val && typeof val === "object" ) {
                  console.log(val,)
                const count = Object.keys(val).length;
                // const count = params.data?.[`${key}_count`] || 0;
                console.log(params,"params in generate column defs")
                  return (
                    <div>
                      <FileOutlined
                        onClick={() => onIconClick(val)}
                        style={{ cursor: "pointer" }}
                      />
                      <span>{count}</span>
                    </div>
                  );
                }

              
           
                return typeof val === "string"
                  ? val  
                  : val  
                    // ? JSON.stringify(val)
                    ? " "
                    : " ";  
              },

              

            };
          }
        }
  
        if (typeof value === "object" && value !== null && !Array.isArray(value) ) {
          if (!columnDefsMap[headerName]) {
            columnDefsMap[headerName] = {
              headerName: headerName,
              field: key,
              enableRowGroup: true,
              groupDefaultExpanded: 0,
              sortable: true,
              filter: filterType,
              // filter:"agNumberCoulmnFilter",
              minWidth: 300,
        
              cellRenderer: (params) => {
                console.log("params data:",params.value)
                console.log("key is:",key)
                const val = params.value||params.data?.[key];
                console.log(val,"val@@@@@")
                console.log(params,"params in generate column Defs")
                

                if (val && typeof val === "object" ) {
                  const count = params.data?.[`${key}_count`] || 0;
                  console.log(count,"count in generate column Defs")
                // const count = Object.keys(val).length;
                  return (
                    <div>
                      <FileOutlined
                        onClick={() => onIconClick(val)}
                        style={{ cursor: "pointer" }}
                      />
                      <span>{count}</span>
                    </div>
                  );
                }

              
           
                return typeof val === "string"
                  ? val  
                  : val  
                    ? JSON.stringify(val)
               
                    : " ";  
              },

              

              
            };
          }



          if (level >= 2) {
            console.log("*******************************")
            let firstChildOpen = true;
            console.log(value, "value in the second level")
            Object.keys(value).forEach((innerKey, index) => {
              const secondLevelValue = value[innerKey];
              const secondLevelHeaderName = innerKey.replace(/_/g, " ");
              const field = `${key}.${innerKey}`;
              const secondLevelFilterType = determineFilterType([secondLevelValue])
              if (!columnDefsMap[headerName].children) {
                columnDefsMap[headerName].children = [];
              }
              // const isFirstChild = index === 0;

              const columnGroupShowValue = field === "mapped_invoice_data.invoice_number"|| field === "validated_data.workspace"|| field ==="raw_text_invoice_data.total_pages"|| field==="file_details.invoice_asset_link"|| field==="status.parser_success_status"|| field === "two_b_data.two_b_data_status" ? "closed" : (firstChildOpen ? "open" : "closed") ;

            

              if (
                !columnDefsMap[headerName].children.some(
                  (child) => child.field === field
                )
              ) {
                columnDefsMap[headerName].children.push({
                  // columnGroupShow: firstChildOpen ? "open" : "closed",
                  columnGroupShow: columnGroupShowValue,

                  headerName: secondLevelHeaderName,
                  field: field,
                  enableRowGroup: true,
                  // groupDefaultExpanded: isFirstChild ? -1 : 0,
                  filter: secondLevelFilterType,
                  minWidth: 300,
                  cellRenderer: (params) => {
                    const val = params.value;
                    if (typeof val === "string" && urlPattern.test(val)) {

                      setpdfFieldName(field)
                      return <TextLinkRenderer1
                        value={val}
                        api={gridApi}
                        handleClick={togglePdfSidePanel}
                        pdfFieldName={val}
                      />;

                    }

                    
                    if (val && typeof val === "object") {
                      const count = Object.keys(val).length;
                      console.log("Value:", val, "Type of val:", typeof val, "at key:", key);
                      // const count = value[innerKey + "_count"] || 0;
                      // console.log(value[innerKey],"innerKey")
                      return (
                        <div>
                          <FileOutlined
                            onClick={() => onIconClick(val)}
                            style={{ cursor: "pointer" }}
                          />
                          <span>{count}</span>
                        </div>
                      );
                    }

                    if (typeof val==="object"&& val?.length > 0) {
                      console.log("Handling array...");
                      // Process each item in the array
                      return (
                        <div>
                       <div>
                          <FileOutlined
                            onClick={() => onIconClick(val)}
                            style={{ cursor: "pointer" }}
                          />
                        
                        </div>
                        </div>
                      );
                    }

                  

                    
                    return typeof val === "string"
                      ? val
                      : val
                        ? JSON.stringify(val)
                        : " ";
                  },
                });
                // if (isFirstChild) {
                //   firstChildOpen = true;
                // }

              }
              if (key === 'two_b_data') {
                // Ensure the two_b_data group column exists
                if (!columnDefsMap[headerName]) {
                  columnDefsMap[headerName] = {
                    headerName: headerName,
                    field: key,
                    enableRowGroup: true,
                    groupDefaultExpanded: 0,
                    filter: filterType,
                    minWidth: 300,
                    children: [] // Initialize children array
                  };
                }
                const twoBDataGroup = columnDefsMap[headerName];
                // Add Two B Data Status as the first child
                if (!twoBDataGroup.children.some(child => child.field === 'two_b_data_status')) {
                  twoBDataGroup.children.unshift({
                    headerName: 'Two B Data Status',
                    field: 'two_b_data_status', // Virtual field for status
                    enableRowGroup: true,
                    sortable: true,
                    filter: 'agSetColumnFilter',
                    minWidth: 200,
                    cellRenderer: (params) => {
                      const twoBValue = params.data ? params.data['two_b_data'] : undefined;
                      if (!twoBValue) {
                        return "No Match";
                      } else if (typeof twoBValue === "object" && !Array.isArray(twoBValue)) {
                        return "Match";
                      } else if (Array.isArray(twoBValue) && twoBValue.length > 0) {
                        return "Multiple Matches";
                      }
                      return "****";
                    }
                  });
                }
              }

                if (key === 'booking_match') {
                  // Ensure the two_b_data group column exists
                  if (!columnDefsMap[headerName]) {
                    columnDefsMap[headerName] = {
                      headerName: headerName,
                      field: key,
                      enableRowGroup: true,
                      groupDefaultExpanded: 0,
                      filter: filterType,
                      minWidth: 300,
                      children: [] // Initialize children array
                    };
                  }

                const BookingMatchGroup = columnDefsMap[headerName];

                if (!BookingMatchGroup.children.some(child => child.field === 'booking_match_status')) {
                  BookingMatchGroup.children.unshift({
                    headerName: 'Booking Match Status',
                    field: 'booking_match_status', // Virtual field for status
                    enableRowGroup: true,
                    sortable: true,
                    filter: 'agTextColumnFilter',
                    minWidth: 200,
                    cellRenderer: (params) => {
                      const bookingMatchValue = params.data ? params.data['booking_match'] : undefined;
                      if (bookingMatchValue==="N/A") {
                        return "No Match";
                      } else if (typeof bookingMatchValue === "object" && !Array.isArray(bookingMatchValue)) {
                        return "Match";
                      } else if (Array.isArray(bookingMatchValue) && bookingMatchValue.length > 0) {
                        return "Multiple Matches";
                      }
                      return "****";
                    }
                  });
                
              }
                }

              if (
                level >= 3 &&
                typeof secondLevelValue === "object" &&
                secondLevelValue !== null
                &&
                !Array.isArray(secondLevelValue)
              ) {
                let secondLevelColumn = columnDefsMap[headerName].children.find(
                  (child) => child.field === field
                );
                if (!secondLevelColumn.children) {
                  secondLevelColumn.children = [];
                }

                let secondLevelChildOpen = false;

                Object.keys(secondLevelValue).forEach((thirdKey) => {
                  const thirdLevelValue = secondLevelValue[thirdKey];
                  const thirdLevelHeaderName = thirdKey.replace(/_/g, " ");
                  const thirdLevelField = `${key}.${innerKey}.${thirdKey}`;
                  const thirdLevelFilterType = determineFilterType([thirdLevelValue]);

                  if (
                    !secondLevelColumn.children.some(
                      (child) => child.field === thirdLevelField
                    )
                  ) {
                    secondLevelColumn.children.push({
                      headerName: thirdLevelHeaderName,
                      field: thirdLevelField,
                      enableRowGroup: true,
                      groupDefaultExpanded: 0,
                      filter: thirdLevelFilterType,
                      minWidth: 300,
                      cellRenderer: (params) => {
                        const val = params.value;
                        if (typeof val === "string" && urlPattern.test(val)) {
                          setpdfFieldName(thirdLevelField)
                          return <TextLinkRenderer1
                            value={pdfLink}
                            api={gridApi}
                            handleClick={togglePdfSidePanel}
                            pdfFieldName={val}
                          />;
                        }
                        if (val && typeof val === "object" && typeof val === "array") {
                          const count = Object.keys(val).length;
                          return (
                            <div>
                              <FileOutlined
                                onClick={() => onIconClick(val)}
                                style={{ cursor: "pointer" }}
                              />
                              <span>{count}</span>
                            </div>
                          );
                        }
                        return typeof val === "string"
                          ? val
                          : val
                            ? JSON.stringify(val)
                            : " ";
                      },
                    });
                    secondLevelChildOpen = true;

                    if (
                      level >= 4 &&
                      typeof thirdLevelValue === "object" &&
                      thirdLevelValue !== null &&
                      !Array.isArray(thirdLevelValue)
                    ) {
                      let thirdLevelColumn = secondLevelColumn.children.find(
                        (child) => child.field === thirdLevelField
                      );
                      if (!thirdLevelColumn.children) {
                        thirdLevelColumn.children = [];
                      }
                      let thirdLevelChildOpen = false;

                      Object.keys(thirdLevelValue).forEach((fourthKey) => {
                        const fourthLevelHeaderName = fourthKey.replace(/_/g, " ");
                        const fourthLevelField = `${key}.${innerKey}.${thirdKey}.${fourthKey}`;

                        if (
                          !thirdLevelColumn.children.some(
                            (child) => child.field === fourthLevelField
                          )
                        ) {
                          thirdLevelColumn.children.push({
                            headerName: fourthLevelHeaderName,
                            field: fourthLevelField,
                            enableRowGroup: true,
                            columnGroupShow: thirdLevelChildOpen ? "open" : "closed",
                            groupDefaultExpanded: 0,
                            filter: true,
                            minWidth: 300,
                            cellRenderer: (params) => {
                              const val = params.value;
                              if (
                                typeof val === "string" &&
                                urlPattern.test(val)
                              ) {
                                setpdfFieldName(fourthLevelField)
                                return (
                                  <TextLinkRenderer1
                                    value={pdfLink}
                                    api={gridOptions.api}
                                    handleClick={togglePdfSidePanel}
                                    pdfFieldName={val}
                                  />
                                );
                              }
                              if (val && typeof val === "object") {
                                const count = Object.keys(val).length;
                                return (
                                  <div>
                                    <FileOutlined
                                      onClick={() => onIconClick(val)}
                                      style={{ cursor: "pointer" }}
                                    />
                                    <span>{count}</span>
                                  </div>
                                );
                              }
                              return typeof val === "string"
                                ? val
                                : val
                                  ? JSON.stringify(val)
                                  : " ";
                            },
                          });
                        }
                      });
                      thirdLevelChildOpen = true;
                    }
                  }
                });
              }
            });
          } else if (Array.isArray(value)) {
            const singleColumnName = key.replace(/_/g, " ");

            if (!columnDefsMap[singleColumnName]) {
              columnDefsMap[singleColumnName] = {
                headerName: singleColumnName,
                field: key,
                enableRowGroup: true,
                groupDefaultExpanded: 0,
                minWidth: 240,
                cellRenderer: (params) => {
                  const arrayValue = params.value;
                  return (
                    <div>
                      {Array.isArray(arrayValue) && (
                        <FileOutlined
                          onClick={() => onIconClick(arrayValue)}
                          style={{ cursor: "pointer" }}
                        />
                      )}
                      <span>
                        {Array.isArray(arrayValue) ? arrayValue.length : ""}
                      </span>
                    </div>
                  );
                },
              };
            }
          } else if (typeof value !== "object") {
            const singleColumnName = key.replace(/_/g, " ");
            if (!columnDefsMap[singleColumnName]) {
              columnDefsMap[singleColumnName] = {
                headerName: singleColumnName,
                field: key,
                enableRowGroup: true,
                groupDefaultExpanded: 0,
                minWidth: 240,
                cellRenderer: (params) => {
                  const val = params.value;
                  if (typeof val === "string" && urlPattern.test(val)) {
                    return <TextLinkRenderer1
                      value={pdfLink}
                      api={gridApi}
                      handleClick={togglePdfSidePanel}
                    />;
                  }
                  return val;
                },
              };
            }
          }
        }
      });

    });


    // return Object.values(columnDefsMap);

    const columnDefs = Object.values(columnDefsMap);

    columnDefs.sort((a, b) => {
      const aPriority = priorityFields.indexOf(a.field);
      const bPriority = priorityFields.indexOf(b.field);
  
      if (aPriority === -1 && bPriority === -1) {
        return 0; // Keep relative order for non-priority fields
      }
      if (aPriority === -1) return 1; // Non-priority fields come after priority fields
      if (bPriority === -1) return -1; // Priority fields come before non-priority fields
  
      return aPriority - bPriority; // Sort by priority index
    });
  
    return columnDefs;
  };
  // const generateColumnDefs = (data, level) => {
  //   console.log(data, "data*******")
  //   console.log(level, "level")
  //   if (!data || data.length === 0) return [];
  //   let columnDefsMap = {};

  //   columnDefsMap = {
  //     Workspace: {
  //       headerName: "Workspace",
  //       field: "validated_data.workspace",
  //       cellRenderer: (params) => params.value || "N/A", // Customize as needed
  //       minWidth: 240,
  //       filter: "agTextColumnFilter",
  //       sortable: true,
  //       resizable: true,
  //       enableRowGroup: true,
  //       checkboxSelection: () => {
  //         console.log("Checkbox enabled for all nodes");
  //         return true;
  //       },
  //     },
  //     Hotel: {
  //       headerName: "Hotel Name",
  //       field: "mapped_invoice_data.hotel_name",
  //       cellRenderer: (params) => params.value || "N/A", // Customize as needed
  //       minWidth: 240,
  //       filter: "agTextColumnFilter",
  //       sortable: true,
  //       resizable: true,
  //       enableRowGroup: true,
      
  //     },
  //     Booking_Match:{
  //       headerName:"Booking Match",
  //       field:"booking_match",
  //       cellRenderer: (params) => {
  //         const val = params.value;
  //         if (val && typeof val === "object") {
  //         const count = Object.keys(val).length;
  //           return (
  //             <div>
  //               <FileOutlined
  //                 onClick={() => onIconClick(val)}
  //                 style={{ cursor: "pointer" }}
  //               />
  //               <span>{count}</span>
  //             </div>
  //           );
  //         }

          
  //         // Default rendering for strings and other types
  //         return typeof val === "string"
  //           ? val  // For string types, just render the string
  //           : val  // For other truthy values, use JSON.stringify
  //             ? JSON.stringify(val)
  //             : " ";  // For falsy values, return an empty space
  //       },
  //     }
  //   }

  //   const urlPattern = /^https:\/\/files\.finkraft\.ai\/[a-f0-9]{32}$/;

  //   console.log(columnDefsMap, "*******************")

  //   const determineFilterType = (values) => {
  //     if (!values || values.length === 0) return null;
  //     const sampleValue = values.find((value) => value !== null && value !== undefined);

  //     if (typeof sampleValue === "number") {
  //       return "agNumberColumnFilter";
  //     } else if (typeof sampleValue === "string") {
  //       return "agTextColumnFilter";
  //     } else if (typeof sampleValue === "boolean") {
  //       return "agSetColumnFilter";
  //     } else if (Array.isArray(sampleValue)) {
  //       return null;
  //     } else if (typeof sampleValue === "object") {
  //       return null;
  //     }
  //     return null;
  //   };

  //   let pdfFieldName = "";
  //   const normalizedData = Array.isArray(data) ? data : [data];
  //   const priorityFields = ["validated_data.workspace", "mapped_invoice_data.hotel_name","mapped_invoice_data", "two_b_data","booking_match"]; 

   
  //   normalizedData.forEach((item) => {
  //     Object.keys(item).forEach((key) => {
  //       const value = item[key];
  //       const headerName = key.replace(/_/g, " ");
  //       const values = normalizedData.map((row) => row[key]);
  //       const filterType = determineFilterType(values);
  //       if (typeof value !== "object" || value === null) {
  //         if (!columnDefsMap[headerName]) {
  //           columnDefsMap[headerName] = {
  //             headerName: headerName,
  //             field: key,
  //             filter: filterType,
  //             enableRowGroup: true,
  //             sortable: true,
  //             resizable: true,
  //             minWidth: 300,
              

  //           };
  //         }
  //       }
  //       if (typeof value === "object" && value !== null && !Array.isArray(value)) {
  //         if (!columnDefsMap[headerName]) {
  //           columnDefsMap[headerName] = {
  //             headerName: headerName,
  //             field: key,
  //             enableRowGroup: true,
  //             groupDefaultExpanded: 0,
  //             filter: filterType,
  //             minWidth: 300,
  //             // rowGroup:true,
  //             cellRenderer: (params) => {
  //               const val = params.value;
  //               if (val && typeof val === "object") {
  //               const count = Object.keys(val).length;
  //                 return (
  //                   <div>
  //                     <FileOutlined
  //                       onClick={() => onIconClick(val)}
  //                       style={{ cursor: "pointer" }}
  //                     />
  //                     <span>{count}</span>
  //                   </div>
  //                 );
  //               }
  //               return typeof val === "string"
  //                 ? val
  //                 : val
  //                   ? JSON.stringify(val)
  //                   : " ";
  //             },
  //           };
  //         }

  //         if (level >= 2) {
  //           console.log("*******************************")
  //           let firstChildOpen = true;
  //           console.log(value, "value in the second level")
  //           Object.keys(value).forEach((innerKey, index) => {
  //             const secondLevelValue = value[innerKey];
  //             const secondLevelHeaderName = innerKey.replace(/_/g, " ");
  //             const field = `${key}.${innerKey}`;
  //             const secondLevelFilterType = determineFilterType([secondLevelValue])
  //             if (!columnDefsMap[headerName].children) {
  //               columnDefsMap[headerName].children = [];
  //             }
  //             // const isFirstChild = index === 0;

  //             const columnGroupShowValue = field === "mapped_invoice_data.invoice_number" || field === "two_b_data._id" ? "closed" : (firstChildOpen ? "open" : "closed");

  //             if (
  //               !columnDefsMap[headerName].children.some(
  //                 (child) => child.field === field
  //               )
  //             ) {
  //               columnDefsMap[headerName].children.push({
  //                 // columnGroupShow: firstChildOpen ? "open" : "closed",
  //                 columnGroupShow: columnGroupShowValue,

  //                 headerName: secondLevelHeaderName,
  //                 field: field,
  //                 enableRowGroup: true,
  //                 // groupDefaultExpanded: isFirstChild ? -1 : 0,
  //                 filter: secondLevelFilterType,
  //                 minWidth: 300,
  //                 cellRenderer: (params) => {
  //                   const val = params.value;
  //                   if (typeof val === "string" && urlPattern.test(val)) {

  //                     setpdfFieldName(field)
  //                     return <TextLinkRenderer1
  //                       value={val}
  //                       api={gridApi}
  //                       handleClick={togglePdfSidePanel}
  //                       pdfFieldName={val}
  //                     />;

  //                   }

  //                   if (val && typeof val === "object") {
  //                     const count = Object.keys(val).length;
  //                     // const count = value[innerKey + "_count"] || 0;
  //                     // console.log(value[innerKey],"innerKey")
  //                     return (
  //                       <div>
  //                         <FileOutlined
  //                           onClick={() => onIconClick(val)}
  //                           style={{ cursor: "pointer" }}
  //                         />
  //                         <span>{count}</span>
  //                       </div>
  //                     );
  //                   }
  //                   return typeof val === "string"
  //                     ? val
  //                     : val
  //                       ? JSON.stringify(val)
  //                       : " ";
  //                 },
  //               });
  //               // if (isFirstChild) {
  //               //   firstChildOpen = true;
  //               // }

  //             }
  //             if (
  //               level >= 3 &&
  //               typeof secondLevelValue === "object" &&
  //               secondLevelValue !== null
  //               &&
  //               !Array.isArray(secondLevelValue)
  //             ) {
  //               let secondLevelColumn = columnDefsMap[headerName].children.find(
  //                 (child) => child.field === field
  //               );
  //               if (!secondLevelColumn.children) {
  //                 secondLevelColumn.children = [];
  //               }

  //               let secondLevelChildOpen = false;

  //               Object.keys(secondLevelValue).forEach((thirdKey) => {
  //                 const thirdLevelValue = secondLevelValue[thirdKey];
  //                 const thirdLevelHeaderName = thirdKey.replace(/_/g, " ");
  //                 const thirdLevelField = `${key}.${innerKey}.${thirdKey}`;
  //                 const thirdLevelFilterType = determineFilterType([thirdLevelValue]);

  //                 if (
  //                   !secondLevelColumn.children.some(
  //                     (child) => child.field === thirdLevelField
  //                   )
  //                 ) {
  //                   secondLevelColumn.children.push({
  //                     headerName: thirdLevelHeaderName,
  //                     field: thirdLevelField,
  //                     enableRowGroup: true,
  //                     groupDefaultExpanded: 0,
  //                     filter: thirdLevelFilterType,
  //                     minWidth: 300,
  //                     cellRenderer: (params) => {
  //                       const val = params.value;
  //                       if (typeof val === "string" && urlPattern.test(val)) {
  //                         setpdfFieldName(thirdLevelField)
  //                         return <TextLinkRenderer1
  //                           value={pdfLink}
  //                           api={gridApi}
  //                           handleClick={togglePdfSidePanel}
  //                           pdfFieldName={val}
  //                         />;
  //                       }
  //                       if (val && typeof val === "object" && typeof val === "array") {
  //                         const count = Object.keys(val).length;
  //                         return (
  //                           <div>
  //                             <FileOutlined
  //                               onClick={() => onIconClick(val)}
  //                               style={{ cursor: "pointer" }}
  //                             />
  //                             <span>{count}</span>
  //                           </div>
  //                         );
  //                       }
  //                       return typeof val === "string"
  //                         ? val
  //                         : val
  //                           ? JSON.stringify(val)
  //                           : " ";
  //                     },
  //                   });
  //                   secondLevelChildOpen = true;

  //                   if (
  //                     level >= 4 &&
  //                     typeof thirdLevelValue === "object" &&
  //                     thirdLevelValue !== null &&
  //                     !Array.isArray(thirdLevelValue)
  //                   ) {
  //                     let thirdLevelColumn = secondLevelColumn.children.find(
  //                       (child) => child.field === thirdLevelField
  //                     );
  //                     if (!thirdLevelColumn.children) {
  //                       thirdLevelColumn.children = [];
  //                     }
  //                     let thirdLevelChildOpen = false;

  //                     Object.keys(thirdLevelValue).forEach((fourthKey) => {
  //                       const fourthLevelHeaderName = fourthKey.replace(/_/g, " ");
  //                       const fourthLevelField = `${key}.${innerKey}.${thirdKey}.${fourthKey}`;

  //                       if (
  //                         !thirdLevelColumn.children.some(
  //                           (child) => child.field === fourthLevelField
  //                         )
  //                       ) {
  //                         thirdLevelColumn.children.push({
  //                           headerName: fourthLevelHeaderName,
  //                           field: fourthLevelField,
  //                           enableRowGroup: true,
  //                           columnGroupShow: thirdLevelChildOpen ? "open" : "closed",
  //                           groupDefaultExpanded: 0,
  //                           filter: true,
  //                           minWidth: 300,
  //                           cellRenderer: (params) => {
  //                             const val = params.value;
  //                             if (
  //                               typeof val === "string" &&
  //                               urlPattern.test(val)
  //                             ) {
  //                               setpdfFieldName(fourthLevelField)
  //                               return (
  //                                 <TextLinkRenderer1
  //                                   value={pdfLink}
  //                                   api={gridOptions.api}
  //                                   handleClick={togglePdfSidePanel}
  //                                   pdfFieldName={val}
  //                                 />
  //                               );
  //                             }
  //                             if (val && typeof val === "object") {
  //                               const count = Object.keys(val).length;
  //                               return (
  //                                 <div>
  //                                   <FileOutlined
  //                                     onClick={() => onIconClick(val)}
  //                                     style={{ cursor: "pointer" }}
  //                                   />
  //                                   <span>{count}</span>
  //                                 </div>
  //                               );
  //                             }
  //                             return typeof val === "string"
  //                               ? val
  //                               : val
  //                                 ? JSON.stringify(val)
  //                                 : " ";
  //                           },
  //                         });
  //                       }
  //                     });
  //                     thirdLevelChildOpen = true;
  //                   }
  //                 }
  //               });
  //             }
  //           });
  //         } else if (Array.isArray(value)) {
  //           const singleColumnName = key.replace(/_/g, " ");

  //           if (!columnDefsMap[singleColumnName]) {
  //             columnDefsMap[singleColumnName] = {
  //               headerName: singleColumnName,
  //               field: key,
  //               enableRowGroup: true,
  //               groupDefaultExpanded: 0,
  //               minWidth: 240,
  //               cellRenderer: (params) => {
  //                 const arrayValue = params.value;
  //                 return (
  //                   <div>
  //                     {Array.isArray(arrayValue) && (
  //                       <FileOutlined
  //                         onClick={() => onIconClick(arrayValue)}
  //                         style={{ cursor: "pointer" }}
  //                       />
  //                     )}
  //                     <span>
  //                       {Array.isArray(arrayValue) ? arrayValue.length : ""}
  //                     </span>
  //                   </div>
  //                 );
  //               },
  //             };
  //           }
  //         } else if (typeof value !== "object") {
  //           const singleColumnName = key.replace(/_/g, " ");
  //           if (!columnDefsMap[singleColumnName]) {
  //             columnDefsMap[singleColumnName] = {
  //               headerName: singleColumnName,
  //               field: key,
  //               enableRowGroup: true,
  //               groupDefaultExpanded: 0,
  //               minWidth: 240,
  //               cellRenderer: (params) => {
  //                 const val = params.value;
  //                 if (typeof val === "string" && urlPattern.test(val)) {
  //                   return <TextLinkRenderer1
  //                     value={pdfLink}
  //                     api={gridApi}
  //                     handleClick={togglePdfSidePanel}
  //                   />;
  //                 }
  //                 return val;
  //               },
  //             };
  //           }
  //         }
  //       }
  //     });

  //   });


  //   // return Object.values(columnDefsMap);

  //   const columnDefs = Object.values(columnDefsMap);

  //   columnDefs.sort((a, b) => {
  //     const aPriority = priorityFields.indexOf(a.field);
  //     const bPriority = priorityFields.indexOf(b.field);
  
  //     if (aPriority === -1 && bPriority === -1) {
  //       return 0; // Keep relative order for non-priority fields
  //     }
  //     if (aPriority === -1) return 1; // Non-priority fields come after priority fields
  //     if (bPriority === -1) return -1; // Priority fields come before non-priority fields
  
  //     return aPriority - bPriority; // Sort by priority index
  //   });
  
  //   return columnDefs;
  // };
  
  console.log(gridApi, "grid api")

  const rowGroupPanelShow = "always";
  const togglePdfSidePanel = (params) => {
    console.log(params, "params")
    if (params.api) {
      params.api.openToolPanel("pdfRenderer");
    } else {
      console.error("API is not available in params");
    }
  };


  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const fetchDataAndUpdateColumns = useCallback(async () => {
    if (!gridApi) return;

    try {
      const response = await fetch(
        'https://stage-apiplatform.finkraftai.com/api/finalytics/tables/data/columnDocument?database=Hotel_Invoices_Recon&collection=report_invoice_2b_plan'
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("first doc", data);

      const levelMapping = {
        "1st": 1,
        "2nd": 2,
        "3rd": 3,
        "4th": 4
      };

      const currentLevel = levelMapping[selectedLevel];
      const generatedColumnDefs = generateColumnDefs(data.data, currentLevel);
      gridApi.setGridOption("columnDefs", generatedColumnDefs);

      setColumnDefinitions(gridApi, data, levelMapping, selectedLevel);


      // const generatedColumnDefs = generateColumnDefs(data.data, currentLevel);

      // // Initial setup of column definitions only here
      // gridApi.setGridOption("columnDefs", generatedColumnDefs);

      const datasource = getServerSideDatasource();
      gridApi.setGridOption("serverSideDatasource", datasource);

    } catch (error) {
      console.error('Error during grid initialization:', error);
    }
  }, [gridApi, selectedLevel]);

  useEffect(() => {
    fetchDataAndUpdateColumns();
  }, [fetchDataAndUpdateColumns]);


  const setColumnDefinitions = (gridApi, data, levelMapping, selectedLevel) => {
    const currentLevel = levelMapping[selectedLevel];
    console.log(data.rows, "data in set column def")
    const generatedColumnDefs = generateColumnDefs(data.rows, currentLevel);

    gridApi.setGridOption("columnDefs", generatedColumnDefs);

    console.log("Column definitions have been set", generatedColumnDefs);


  };



  const handleLevelChange = (value) => {
    setSelectedLevel(value);

  };





  const getColumnData = () => {
    const api = gridRef.current.api;
    const filteredNodes = [];
    api.forEachNodeAfterFilter((node) => filteredNodes.push(node));
    const columnField = "_id";
    const filtercolumnData = filteredNodes.map(
      (node) => node.data[columnField]
    );
    const filterKeyValue = {
      key: columnField,
      values: filtercolumnData,
    };
    sendFilterDataToBackend(filterKeyValue);
  };

  const sendFilterDataToBackend = async (data) => {
    try {
      const response = await fetch(`${host}/applyfilter`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const responseData = await response.json();
      console.log("Response from backend:", responseData);
      message.success("Filter applied successfully");
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      message.error("Failed to apply filter");
    }
  };

  const removeFilter = async () => {
    try {
      const response = await axios.post(`${host}/removeFilter`);
      console.log(response);
      message.success("Filter deleted successfully");
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      message.error("Failed to remove filter");
    }
  };


  const onFilterTextBoxChanged = (query) => {
    if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.setQuickFilter(query);
    }
  };

  const downloadPdf = () => {
    setTimeout(() => {
      if (gridRef.current && gridRef.current.api) {
        const gridApi = gridRef.current.api;
        gridApi.exportDataAsCsv({ allColumns: true, suppressQuotes: true });
      } else {
        console.error("Error: gridRef or gridCore not initialized");
      }
    }, 3000);
  };



  const columnDefs = useMemo(() =>

    generateColumnDefs(data, selectedLevel === '1st' ? 1 : selectedLevel === '2nd' ? 2 : selectedLevel === '3rd' ? 3 : 4), [data, selectedLevel]);
  const sideBarConfig = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
      {
        id: "pdfRenderer",
        labelDefault: "PDF View",
        labelKey: "pdfRenderer",
        iconKey: "pdf-file",
        width: 500,
        toolPanel: () => <PdfRenderer api={gridApi} />,
      },
    ],
  }));



  const gridOptions = {

    columnDefs: generateColumnDefs(data, selectedLevel === '1st' ? 1 : selectedLevel === '2nd' ? 2 : 3),
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: true,

      groupable: true
    },
    rowModelType: "serverSide",
    groupUseEntireRow: true,
    rowGroupPanelShow: "always",
    enableRangeSelection: true,
    enableClipboard: true,
    rowSelection: "multiple",
    suppressRowClickSelection: true,
    groupSelectsChildren: true,
    groupDefaultExpanded: 0,
    autoGroupColumnDef: {
      headerName: "Groups",
      field: "validated_data.workspace",
      cellRenderer: 'agGroupCellRenderer',
      cellRendererParams: {
        checkbox: true,
      
      },
      width: 300
    },

  };




  const handlePriorityClick = async (priorityLevel) => {
    const filterModel = gridApi.getFilterModel();
    console.log(filterModel, "filter model in priority click")
    const database = 'Hotel_Invoices_Recon';
    const collection = 'report_invoice_2b_plan';
    const requestBody = {
      database,
      collection,
      filterModel,
      priorityLevel,
    };
    try {
      const response = await fetch("https://stage-apiplatform.finkraftai.com/api/finalytics/tables/data/priorityApply", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });
      const result = await response.json();
      console.log(result, "priority result")
      console.log("Priority update response:", result);
      gridApi.refreshServerSide();
    } catch (error) {
      console.error("Error updating priority:", error);
    }
  };

  function resetPriority() {
    const requestData = {
      database: 'Hotel_Invoices_Recon',
      collection: 'report_invoice_2b_plan',
      filterModel: {}
    };

    fetch('https://stage-apiplatform.finkraftai.com/api/finalytics/tables/data/resetPriority', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestData)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        if (data && data.modified_count !== undefined) {
          alert(`Priority reset for ${data.modified_count} documents.`);
        } else {
          alert('Priority reset successfully, but no modification count returned.');
        }
      })
      .catch(error => {
        console.error('Error resetting priority:', error);
        alert('An error occurred while resetting priority. Please try again.');
      });
  }



  return (
    <div style={containerStyle}>

      <div>
        <label>Select Nested Level: </label>
        <Select defaultValue="1st" style={{ width: 200 }} onChange={handleLevelChange}>
          <Option value="1st">1st Level</Option>
          <Option value="2nd">2nd Level</Option>
          <Option value="3rd">3rd Level</Option>
          <Option value="4th">4th Level</Option>
        </Select>
        {/* <Select id="priority" onChange={handlePriorityFilterChange} value={selectedFilterPriority} style={{ width: "150px" }}>
          <Option value="">Select Priority</Option>
          <Option value="priority1">Priority 1</Option>
          <Option value="priority2">Priority 2</Option>
          <Option value="priority3">Priority 3</Option>
        </Select> */}
        {/* <Button
          type="primary"
          onClick={handleFilterApply}
          style={{ marginLeft: "10px" }}
        >
          Filter to Apply
        </Button> */}
        {/* <Button onClick={resetPriority}>Reset</Button>
        <span id="total-count">Total Count: 0</span> */}
        
        <div className="headerPortion">
          <div className="reportBtn">
            {/* <div className="reportInput">
              <p className="report">Report table</p>
              <Input
                className="inputData"
                style={{ fontSize: '16px' }}
                prefix={<SearchOutlined />}
                placeholder="Search"
                onChange={(e) => onFilterTextBoxChanged(e.target.value)}
              >
              </Input>
            </div> */}
            <div style={{ display: "flex" }}>
              {/* <Button>
                <Link
                  to="/test"
                  style={{ textDecoration: "none" }}
                >
                  Manual Validation
                </Link>
              </Button> */}
              <div className="buttonDown">
                {/* <Button className="btn" onClick={downloadPdf}>
                  <DownloadOutlined />
                  Download CSV
                </Button> */}
              </div>
            </div>
            <Modal
              title="Filter Options"
              visible={isFilterModalVisible}
              onCancel={handleCancelButton}
              footer={[
                <Button key="reset" type="text" onClick={removeFilter}>
                  Reset
                </Button>,
                <Button key="save" type="primary" onClick={getColumnData}>
                  Save Filter
                </Button>,
              ]}
            >
              <p>Select your filter options here.</p>
            </Modal>
          </div>
          {/* <div className="fullDetailInvoice">
            <div className="invoiceDetails">
              <div className="innerInvoice">
                <div className="headerNum">XXXX</div>
                <div className="headerText">Total Claimable GST</div>
              </div>
            </div>
            <div className="invoiceDetails">
              <div className="innerInvoice">
                <div className="headerNum">XX%</div>
                <div className="headerText">Missing Invoice</div>
              </div>
            </div>
            <div className="invoiceDetails">
              <div className="innerInvoice">
                <div className="headerNum">XXXX</div>
                <div className="headerText">Total booking</div>
              </div>
            </div>
          </div> */}
        </div>
      </div>



      <div style={gridStyle} className="ag-theme-alpine">


        <AgGridReact
          resizable={true}
          columnDefs={columnDefs}
          defaultColDef={{
            flex: 1,
            minWidth: 100,
            sortable: false,
          }}
          rowBuffer={0}
          rowModelType={"serverSide"}
          cacheBlockSize={50}
          maxBlocksInCache={2}
          onGridReady={onGridReady}
          rowGroupPanelShow={rowGroupPanelShow}
          sideBar={sideBarConfig}
          gridOptions={gridOptions}
        />

      </div>
      <Modal
        visible={modalVisible}
        onCancel={closeModal}
        footer={null}
        style={{ top: 20, right: 0, position: 'fixed', width: 400 }}
        bodyStyle={{ maxHeight: '100vh', overflowY: 'auto' }}
      >
        <div style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px' }}>
          {selectedDocuments && (
            typeof selectedDocuments === 'object' && !Array.isArray(selectedDocuments) ? (
              <Document documents={[selectedDocuments]} />
            ) : Array.isArray(selectedDocuments) && selectedDocuments.length > 0 ? (
              <Document documents={selectedDocuments} />
            ) : (
              <p>No documents available</p>
            )
          )}
        </div>
      </Modal>
    </div>
  );
};

export default App;
